<template>
  <div class="fixed top-5 right-5 space-y-2 z-50">
    <div
      v-for="toast in toasts"
      :key="toast.id"
      :class="[
        'px-4 py-3 rounded shadow-lg flex items-center justify-between w-80',
        toastClasses[toast.type] || toastClasses.info,
      ]"
    >
      <span class="font-semibold">{{ toast.message }}</span>
      <button type="button" @click="removeToast(toast.id)" class="ml-4 text-white font-bold">
        ×
      </button>
    </div>
  </div>
</template>
<script setup>
import { ref } from "vue";

const toasts = ref([]);

const addToast = (message, type = "info", duration = 5000) => {
  const id = Date.now();
  toasts.value.push({ id, message, type });

  setTimeout(() => {
    toasts.value = toasts.value.filter((toast) => toast.id !== id);
  }, duration);
};

const removeToast = (id) => {
  toasts.value = toasts.value.filter((toast) => toast.id !== id);
};

// Expose function to parent
defineExpose({ addToast });

const toastClasses = {
  success: "bg-green-500 text-white",
  error: "bg-red-500 text-white",
  warning: "bg-yellow-500 text-black",
  info: "bg-blue-500 text-white",
};
</script>
